import React from 'react';
import './arrowFlag.scss';
import PropTypes from 'prop-types';

export const ArrowFlag = ({ text, className, borderColor }) => (
    <div className={`flag ${className} ${borderColor}`}>
        <span>{text}</span>
    </div>
);

ArrowFlag.propTypes = {
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    borderColor: PropTypes.string,
};
